module.exports = __webpack_public_path__ + "static/media/music-lover-radar-beyonce.4e4f8151.png";